var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [_c("customer-info")], 1),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [_c("chat-box", { attrs: { orderId: _vm.order.id } })],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [_c("list-product", { attrs: { order: _vm.order } })],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [_c("bill-of-lading", { attrs: { orderId: _vm.order.id } })],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [_c("amount-detail", { attrs: { order: _vm.order } })],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("status-hist", {
            attrs: { historiesChanged: _vm.order.statusHistories }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("payment-hist", {
            attrs: { paymentHistory: _vm.order.paymentHistory }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("order-complain", {
            attrs: { orderComplains: _vm.order.orderComplains }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("change-hist", {
            attrs: { historiesChanged: _vm.order.changedHistories }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("order-detail-footer", {
            attrs: { order: _vm.order, customerInfo: _vm.customerInfo },
            on: {
              eventCancelOrder: function($event) {
                return _vm.onCancelOrder($event)
              },
              eventDepositOrder: function($event) {
                return _vm.onDepositOrder($event)
              },
              eventReOrder: function($event) {
                return _vm.onReOrder($event)
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }